<template>
	<div class="review">

		<div class="limitWidth1000 px-3 py-2">
			<v-skeleton-loader v-if="loadingDetails" type="paragraph, paragraph"></v-skeleton-loader>
			<iframe
v-if="canSubmitFeedback"
				:data-tally-src="`${FrameUrl}&alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1`"
				loading="lazy" width="100%" height="322" frameborder="0" marginheight="0" marginwidth="0"
				title="Recensione"></iframe>
		</div>

	</div>
</template>

<script>
import CrudClient from "@/services/CrudClient";

export default {
	metaInfo() {
		return {
			title: this.$t("pageTitle"),
			meta: [{ name: "description", content: this.$t("pageMetaDescription") }],
		};
	},
	name: "Home",
	data() {
		return {
			loadingDetails: false,
			canSubmitFeedback: false,
			bookingDetails: null,
		}
	},

	props: {

	},
	computed: {

		BookingId() {
			return this.$route.params.BookingId;
		},

		FrameUrl() {
			const icTallyId = "mOkP1g";
			const vnTallyId = "3xvQry";

			return `https://tally.so/embed/${this.bookingDetails.BookingTypeId === 1 ? icTallyId : vnTallyId}?id=${this.BookingId}`;
		}
	},

	created() {
		this.BookingsService = new CrudClient("CurrentPatient/Bookings");
	},
	async mounted() {
		const tallyScript = document.createElement("script");
		tallyScript.setAttribute("src", "https://tally.so/widgets/embed.js");

		await new Promise((resolve) => {
			tallyScript.onload = resolve;
			document.head.appendChild(tallyScript);
		});

		try {
			this.loadingDetails = true;
			this.bookingDetails = await this.BookingsService.GetSelectedFields(this.BookingId, "BookingId, BookingTypeId, BookingStatusId");

			if (this.bookingDetails.BookingStatusId === 2) {
				this.canSubmitFeedback = true;

				// Add this to reinitialize Tally after iframe becomes visible
				this.$nextTick(() => {
					if (window.Tally) {
						window.Tally.loadEmbeds();
					}
				});
			}
		} catch (error) {
			this.snackError({ Text: this.$t("common.error.cannotLoadData") });
			this.$captureError(error);
		} finally {
			this.loadingDetails = false;
		}
	},

	methods: {

	},
};
</script>
<i18n>
{
	"it":{
		"pageTitle": "Recensione",
		"pageMetaDescription": " Il nutrizionista online su misura per te"
	}
}
</i18n>
